export type LeadFilterState = {
  q: string;
  status: string;
  source: string;
  tag: string;
  page: number;
  pageSize: number;
};

export function toQueryParams(filters: LeadFilterState, projectId: string | null): URLSearchParams {
  const p = new URLSearchParams();
  if (projectId) p.set('project_id', projectId);
  if (filters.q) p.set('q', filters.q);
  if (filters.status) p.set('status', filters.status);
  if (filters.source) p.set('source', filters.source);
  if (filters.tag) p.set('tag', filters.tag);
  p.set('page', String(filters.page));
  p.set('page_size', String(filters.pageSize));
  return p;
}
